export const parseCurrencyString = (input?: string | number | null) => {
  if (input !== null && input !== undefined && input !== '') {
    const value = String(input);
    const currencyMatch = value.match(/^[^\d.-]+/);
    const symbolOrCode = currencyMatch ? currencyMatch[0]?.trim() : '$';
    const cleanedNumber = value.replace(/[^0-9.-]+/g, '');
    const parsedAmount = parseFloat(cleanedNumber);

    // Check if parsedAmount is a float and apply toFixed(2) if true
    const amount = Number.isNaN(parsedAmount)
      ? '-'
      : (parsedAmount % 1 !== 0 ? parsedAmount.toFixed(2) : parsedAmount.toString());

    return {
      symbolOrCode,
      amount,
    };
  } else {
    return {
      symbolOrCode: '$',
      amount: '-',
    };
  }
};
